import { Input, InputProps } from "antd";
import styles from "./input.module.css";

type DefaultInputProps = InputProps & {
  mask?: (value: string) => string;
};

export const DefaultInput: React.FC<DefaultInputProps> = ({
  mask,
  value,
  onChange,
  placeholder,
  children,
  ...rest
}) => {
  const handleChange: InputProps["onChange"] = (e) => {
    let nextValue = e.target.value;

    if (mask) {
      nextValue = mask(nextValue);
    }

    onChange?.({
      ...e,
      target: {
        ...e.target,
        value: nextValue,
      },
    });
  };

  const hasValue = value !== undefined && value !== null && value !== "";

  return (
    <label className={styles.inputBlock}>
      <Input {...rest} className={styles.input} variant="outlined" value={value} onChange={handleChange}>
        {children}
      </Input>

      {placeholder && <span className={`${styles.label} ${hasValue ? styles.labelTop : ""}`}>{placeholder}</span>}
    </label>
  );
};
